import { FC, ReactNode } from "react"
import CloseButton from "shared/components/buttons/CloseButton"
import { P } from "shared/styles/textStyles"
import styled from "styled-components"

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${(props) => props.theme.zIndex.plugin};
`

const ClickAway = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: ${(props) => props.theme.zIndex.modal};
`

const Modal = styled.div<{ $bottom?: boolean }>`
  position: absolute;
  z-index: ${(props) => props.theme.zIndex.modal};
  border-radius: 12px;
  background-color: ${(props) => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  padding: 15px 17px;
  overflow: hidden;
  width: 90%;
  max-width: ${(props) => props.theme.main.minPanelWidth};
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.6);

  // optionally position modal to bottom of parent
  ${(props) =>
    props.$bottom &&
    `
    bottom: 12px;
  `}
`

const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
`

export const ModalText = styled(P)`
  margin: 7px 0 15px;
  text-align: center;
`

type PanelModalProps = {
  closeModal: () => void
  bottom?: boolean
  children?: ReactNode
  closeButtonRobotTag?: string // unique tag for testing library to select this modal's close button
}

export const PanelModal: FC<PanelModalProps> = ({
  closeModal,
  bottom = false,
  children,
  closeButtonRobotTag,
}) => (
  <Wrapper>
    <ClickAway onClick={closeModal} />
    <Modal $bottom={bottom}>
      <Header>
        <CloseButton
          onClose={closeModal}
          size={15}
          showHoverStyles
          robotTag={closeButtonRobotTag ?? "panel-modal-close-button"}
        />
      </Header>
      {children}
    </Modal>
  </Wrapper>
)
